"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get500Error = exports.get400Error = exports.validateOrdinar = exports.validateBasketAmount = exports.getBasketOutcomesNumber = exports.basketOutcomesMapToId = exports.basketOutcomesListToMap = exports.adjustMaxBet = exports.getBasketOutcomeKey = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const values_1 = __importDefault(require("../../../utils/functions/values"));
const keyBy_1 = __importDefault(require("../../../utils/functions/keyBy"));
const sortBy_1 = __importDefault(require("../../../utils/functions/sortBy"));
const _reduxjs_1 = require("../../../utils/@reduxjs");
const format_1 = require("../../../utils/format");
const constants_1 = require("../constants");
/*
A standard basket/event outcome's unique key: eventId + outcomeTypeId + parameters.
Matches basket and event outcomes.
 */
const getBasketOutcomeKey = ({ event: { id: eventId }, probability: { outcomeTypeId, parameters }, }) => {
    return `E${eventId}---O${outcomeTypeId}---P${(0, sortBy_1.default)(parameters, 'type')
        .map((p) => `${p.type}-${p.value}`)
        .join('-')}`;
};
exports.getBasketOutcomeKey = getBasketOutcomeKey;
/*
Adjusting basket outcome's max bet value according to the client numbers format
 */
const adjustMaxBet = (outcome) => ({
    ...outcome,
    maxBet: (0, format_1.adjustAmountForFrontend)(outcome.maxBet),
});
exports.adjustMaxBet = adjustMaxBet;
/*
Write the result of basketOutcomesListToMap to the store only in reset cases.
For all other cases, set basket outcomes values to the store
using computeBasketOutcomesMap, which considers diffs.
 */
const basketOutcomesListToMap = (basketOutcomesList) => {
    return (0, keyBy_1.default)(basketOutcomesList, (basketOutcome) => (0, exports.getBasketOutcomeKey)(basketOutcome));
};
exports.basketOutcomesListToMap = basketOutcomesListToMap;
const basketOutcomesMapToId = (basketOutcomesMap) => (0, _reduxjs_1.toIdsMap)((0, values_1.default)(basketOutcomesMap));
exports.basketOutcomesMapToId = basketOutcomesMapToId;
const getBasketOutcomesNumber = (basketOutcomesMap) => Object.keys(basketOutcomesMap).length;
exports.getBasketOutcomesNumber = getBasketOutcomesNumber;
const validateBasketAmount = ({ amount, maxValue, minValue, }) => {
    let error = null;
    if (maxValue && amount > maxValue) {
        error = constants_1.EAllBasketErrors.BETS_PAY_MAX_EXCEEDED;
    }
    if (!!amount && amount < minValue) {
        error = constants_1.EAllBasketErrors.MIN_AMOUNT_MUST_EXCEED;
    }
    return error;
};
exports.validateBasketAmount = validateBasketAmount;
const validateOrdinar = ({ ordinarOutcomeErrors, minBet, amountTotal, isAppliedCoupon, }) => {
    const amountErrors = [];
    const error = (0, exports.validateBasketAmount)({
        amount: amountTotal,
        minValue: minBet,
    });
    if (error && isAppliedCoupon) {
        amountErrors.push(error);
    }
    // Маппинг ошибок для каждого исхода
    const outcomesErrors = Object.entries(ordinarOutcomeErrors).reduce((acc, [key, { amount, maxBet }]) => {
        const error = (0, exports.validateBasketAmount)({
            amount: +amount,
            maxValue: maxBet,
            minValue: minBet,
        });
        acc[key] = {
            ...acc[key],
            amount,
            maxBet,
            message: error ? constants_1.ALL_BASKET_ERROR_MESSAGES[error] : undefined,
        };
        return acc;
    }, {});
    return { outcomesErrors, amountErrors };
};
exports.validateOrdinar = validateOrdinar;
const get400Error = (error) => {
    const shouldReRequestBasket = constants_1.ERROR_LIST_WHEN_MAKE_RE_REQUEST_BASKET.includes(error.code);
    return {
        shouldReRequestBasket,
        error: error.code,
    };
};
exports.get400Error = get400Error;
const get500Error = (error, outcomesLength) => {
    switch (error.code) {
        case betweb_openapi_axios_1.ErrorCode.BetEventUndefined:
        case betweb_openapi_axios_1.ErrorCode.BetSuspended: {
            if (outcomesLength === 1) {
                return constants_1.EAllBasketErrors.EVENT_CANCELED;
            }
            return null;
        }
        case betweb_openapi_axios_1.ErrorCode.BetChangedCoefficient: {
            if (outcomesLength === 1) {
                return constants_1.EAllBasketErrors.CHANGED_COEFFICIENT;
            }
            return null;
        }
        case betweb_openapi_axios_1.ErrorCode.BetSystemError: {
            return error.code;
        }
        default:
            return null;
    }
};
exports.get500Error = get500Error;
//# sourceMappingURL=index.js.map